/* eslint-disable no-undef */
const env = process.env.NODE_ENV;

const development = {
  api: {
    uri: process.env.REACT_APP_API_DEV,
  },
};
const test = {
  api: {
    uri: process.env.REACT_APP_API_DEV,
  },
};
const production = {
  api: {
    uri: process.env.REACT_APP_API_PROD,
  },
};

const stage = {
  development,
  test,
  production,
};

export const environment = stage[env];
